const bootstrap = require('bootstrap')
const { LiveForm, Nette } = require ('live-form-validation');
import '../scss/custom.scss'
import "../../node_modules/@fancyapps/ui/dist/panzoom.css";
import "../../node_modules/@fancyapps/ui/dist/panzoom.controls.css";
import textareaAutosize from './textareaAutosize';
import confirmationDialog from './confirmationDialog';
import {reactToLeaf} from './phorum.js';
import { Panzoom } from "@fancyapps/ui";
import InfiniteScrollExtension from './infiniteScrollExtension';
import LoadingIndicatorExtension from './loadingIndicatorExtension';
import ScrollExtension from './scrollExtension';
import AjaxifyPaginationExtension from './ajaxifyPaginationExtension';
import naja from 'naja';


document.addEventListener('DOMContentLoaded', ()=>{
    // Live form validation
    window.Nette = Nette;
    window.LiveForm = LiveForm;
    Nette.init();
    LiveForm.setOptions({
      controlErrorClass: 'is-invalid',
      controlValidClass: 'is-valid',
      showValid: true
    });
    // confirm naja ajax
    naja.uiHandler.addEventListener('interaction', (event) => {
      let {element} = event.detail;
      let question = element.dataset.confirm;
      if (question && !confirm(question)) {
        event.preventDefault();
      }
    });
    // naja
    //naja.registerExtension(new InfiniteScrollExtension());
    naja.registerExtension(new LoadingIndicatorExtension('body'));
    naja.registerExtension(new ScrollExtension());
    naja.registerExtension(new AjaxifyPaginationExtension());
    naja.registerExtension(new InfiniteScrollExtension());
    naja.initialize();

    reInitScripts();


});
naja.addEventListener('complete', reInitScripts);

function reInitScripts()  {


    // Enable BS tooltips everywhere
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl));

    // confirm
    document.querySelectorAll('a[data-confirm]:not(.ajax)').forEach(el => {
      confirmationDialog(el);
    });

    // textareaAutosize
    [...document.getElementsByTagName("textarea")].forEach(tx => {
      textareaAutosize(tx);
    });

    // datetime

    // phorum
    document.querySelectorAll('a.reaction').forEach(el => {
      el.addEventListener('click', ()=>{
        reactToLeaf(el);
      });
      
    });

    // panzoom
    if (document.querySelector("#race-map")) {
        const myPanzoom = new Panzoom(document.querySelector("#race-map"), {
        });
    }



}

